import { Status } from '@/types/enums';
interface VideoItem {
  coverLandscape: string;
  coverPortrait: string;
  status: Status;
  youtubeId: string;
  title: string;
  unlockTime: number;
}
let filteredVideos: VideoItem[];
export const filterVideos = (vidoes: VideoItem[]): VideoItem[] => {
  if (vidoes.every((video) => video.status === Status.Close)) {
    filteredVideos = [...vidoes];
  } else if (vidoes.every((video) => video.status === Status.Open)) {
    filteredVideos = [...vidoes].reverse();
  } else {
    filteredVideos = [...vidoes];
    for (let i = 0, n = filteredVideos.length; i < n; i++) {
      if (filteredVideos[i]['status'] === Status.Open) {
        filteredVideos = [filteredVideos.splice(i, 1)[0], ...filteredVideos];
      }
    }
  }
  return filteredVideos;
};
